import { SortDirection, Column } from "../interfaces";

export default function getSortUrlParams(columnKey: string | undefined, direction: SortDirection) {
  return columnKey ? { sortQuery: `${columnKey}-${direction}` } : {};
}

export function sortColumns(a: Column, b: Column): number {
  var orderA = a.order || Number.MAX_VALUE;
  var orderB = b.order || Number.MAX_VALUE;

  return orderA >= orderB ? 1 : -1;
};
